import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import SalesMixin from '@/helpers/mixins/SalesPageMixin';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import UserAgentMixin from '../helpers/mixins/UserAgentMixin';
import WhiteLabelRedirectMixin from '../helpers/mixins/WhiteLabelRedirectMixin';
let GetStarted = class GetStarted extends Mixins(ViewportSizeMixin, UserAgentMixin, SalesMixin, WhiteLabelRedirectMixin) {
    get whiteLabelName() {
        const vm = this;
        return vm.whiteLabelContent ? vm.whiteLabelContent.whiteLabelTitle : 'ChatGenie';
    }
};
GetStarted = __decorate([
    Component
], GetStarted);
export default GetStarted;
